// Exposes `$can('canViewEfficiencyTest')` in every component/template.
// Resolution lives in the `can` store getter (asset-class permission first, then global userPermissions),
// so templates stay reactive to both /api/user/info and asset-class switches.
export default {
  install(Vue) {
    Vue.prototype.$can = function (permission, assetClass) {
      return this.$store.getters.can(permission, assetClass)
    }
  },
}
